import { FC } from 'react'

import List from '~/components/List'
import NameValue from '~/components/NameValue'
import Typography from '~/components/Typography'
import { toAmount } from '~/lib/helpers'
import { useEarn } from '~/lib/useEarns'

import styles from './StakedInfo.pcss'
import { EarnStatus } from '~/contracts/useEarnContract'

const StakedInfo: FC = () => {
	const { contract } = useEarn()

	if (contract.status !== EarnStatus.SUCCESS) {
		return null
	}

	return (
		<div className={styles.stakedInfo}>
			<List>
				<List.Item>
					<NameValue
						name={<Typography>Staked</Typography>}
						value={
							<Typography>
								{toAmount(
									contract.token.decimals,
									contract.earn.userInfo.amount
								)}
							</Typography>
						}
					/>
				</List.Item>
			</List>
		</div>
	)
}

export default StakedInfo
